import { v4 as uuid } from "uuid";
import { browserName } from "react-device-detect";

import store from "../store";
import {
  AUTH_STORAGE_KEYS,
  clearAllPortalLoginSnapshots,
  getAuthStorageKeyForPortal,
  getSessionPortalValue,
  persistPortalLogin,
} from "./authStorage";

export { getSessionPortalValue as getSessionPortal };
export {
  AUTH_STORAGE_KEYS,
  clearOppositePortalStorage,
  getAuthStorageKeyForPortal,
  getInitialAuthLoginState,
  persistPortalLogin,
} from "./authStorage";

export const isAuth = () => {
  const state = store.getState();
  return !!state.auth.login?.auth_token;
};

/**
 * Bearer token for API calls — Redux first (freshest), then persisted portal session.
 */
export const getAuthBearerToken = () => {
  try {
    const fromRedux = store.getState()?.auth?.login?.auth_token;
    if (fromRedux) return String(fromRedux);
  } catch {
    /* store unavailable */
  }
  try {
    const portal = getSessionPortalValue();
    const key = getAuthStorageKeyForPortal(portal);
    let raw =
      localStorage.getItem(key) || sessionStorage.getItem(key);
    if (!raw) {
      raw =
        localStorage.getItem(AUTH_STORAGE_KEYS.LEGACY_ADMIN) ||
        sessionStorage.getItem(AUTH_STORAGE_KEYS.LEGACY_ADMIN);
    }
    if (!raw) return null;
    const blob = JSON.parse(raw);
    const t = blob?.auth_token;
    return t != null && t !== "" ? String(t) : null;
  } catch {
    return null;
  }
};

export const generateDeviceId = () => {
  return `${browserName}-${uuid()}`;
};

export const setDeviceId = (device_id) => {
  return localStorage.setItem("device_id", device_id);
};

export const getDeviceId = () => {
  return localStorage.getItem("device_id");
};

/** Persists login to the storage bucket matching `sessionPortal` (must be set first). */
export const setAdmin = (admin) => {
  const portal = getSessionPortalValue();
  persistPortalLogin(portal, admin);
};

export const clearAdminData = () => {
  localStorage.removeItem("device_id");
  sessionStorage.removeItem("device_id");
  clearAllPortalLoginSnapshots();
  localStorage.removeItem("userType");
  sessionStorage.removeItem("userType");
  localStorage.removeItem("sessionPortal");
  sessionStorage.removeItem("sessionPortal");
};
